import { useNavigate } from "react-router";
import { TopNavigation } from "@hamlak/ui";
import logoUrl from "@hamlak/ui/brand/logo.svg";
import { t } from "@/i18n/ko";
import { OpenInBrowserNotice } from "@/components/OpenInBrowserNotice";
import { useUiStore } from "@/stores/uiStore";
import "./auth.css";

/**
 * 웹 인앱 브라우저(카카오톡·인스타그램 등) 전용. Google OAuth가 막히므로 로그인을 시도하지 않고 외부 브라우저 안내만.
 * returnTo를 쿼리로 실어 외부 브라우저에서도 /login → 복귀가 이어진다. 비회원 열람은 인앱에서도 그대로.
 */
export function OpenInBrowserPage() {
  const navigate = useNavigate();
  const returnTo = useUiStore((s) => s.returnTo);
  const href = typeof window !== "undefined" ? withReturnTo(window.location.href, returnTo) : "";
  return (
    <main className="page auth">
      <TopNavigation tone="transparent" title="" right={null} onBack={() => navigate(-1)} />
      <div className="auth__hero">
        <img src={logoUrl} alt={t("app.name")} width={140} />
        <p className="auth__hero-text">{t("login.openInBrowser.title")}</p>
      </div>
      <div className="auth__body">
        <OpenInBrowserNotice href={href} />
      </div>
    </main>
  );
}

function withReturnTo(href: string, returnTo: string | null): string {
  if (!returnTo) return href;
  const u = new URL(href);
  u.pathname = "/login";
  u.searchParams.set("returnTo", returnTo);
  return u.toString();
}
